import WalletConnectProvider from '@walletconnect/web3-provider';
import { IProviderOptions } from 'web3modal';
import { NETWORKS } from './constants';

export const providerOptions: IProviderOptions = {
  walletconnect: {
    package: WalletConnectProvider,
    options: {
      rpc: {
        1: NETWORKS['1'].rpc,
        4: NETWORKS['4'].rpc,
      },
    },
  },
};
